var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArquivar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8147 13.0245L11.2879 9.5513L10.0723 8.33568L8.683 9.72496V6.0781H6.9464V9.72496L5.55712 8.33568L4.3415 9.5513L7.8147 13.0245ZM1.7366 4.3415V13.8928H13.8928V4.3415H1.7366ZM1.7366 15.6294C1.25903 15.6294 0.85021 15.4594 0.510126 15.1193C0.170042 14.7792 0 14.3704 0 13.8928V3.06076C0 2.85815 0.0325612 2.66279 0.0976837 2.47465C0.162806 2.28652 0.26049 2.11286 0.390735 1.95367L1.47611 0.629517C1.6353 0.426914 1.83428 0.271344 2.07307 0.162806C2.31185 0.0542687 2.56148 0 2.82197 0H12.8074C13.0679 0 13.3175 0.0542687 13.5563 0.162806C13.7951 0.271344 13.9941 0.426914 14.1533 0.629517L15.2387 1.95367C15.3689 2.11286 15.4666 2.28652 15.5317 2.47465C15.5968 2.66279 15.6294 2.85815 15.6294 3.06076V13.8928C15.6294 14.3704 15.4594 14.7792 15.1193 15.1193C14.7792 15.4594 14.3704 15.6294 13.8928 15.6294H1.7366ZM2.08392 2.6049H13.5455L12.8074 1.7366H2.82197L2.08392 2.6049Z",
    fill: "#865829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArquivar);
export default __webpack_public_path__ + "static/media/arquivar.717ceb86b054d689646e88a0a84b3fc1.svg";
export { ForwardRef as ReactComponent };